import { render, staticRenderFns } from "./ChatbotAnswerChart.vue?vue&type=template&id=a25fb874"
import script from "./ChatbotAnswerChart.vue?vue&type=script&lang=js"
export * from "./ChatbotAnswerChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotAnswerChart.vue?vue&type=style&index=0&id=a25fb874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports